import React from 'react'
import { useTheme } from '@mui/material'

interface IIconProps {
  width?: string
  color?: string
}

const DeathIcon: React.FC<IIconProps> = (props) => {
  const theme = useTheme()
  return (
    <svg
      height={props.width} width={props.width} fill={props.color || theme.palette.text.primary} viewBox='-76 0 512 512'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='m225 512v-301h135v-90h-135v-121h-90v121h-135v90h135v301zm0 0' />
    </svg>
  )
}
export default DeathIcon
